import * as React from "react";

const SvgComponent = ({ bg = "transparent", color = "var(--filter-bar-btn-border)", stroke = "var(--filter-bar-btn-border)", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={bg}
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <g opacity={0.6} fill={color}>
      <path d="M14.983 12.998c.287.001.561-.113.763-.316l1.965-1.965a1.176 1.176 0 0 1 1.609-.05 1.116 1.116 0 0 1 0 1.576l-2.012 2.011a1.081 1.081 0 0 0 0 1.525 1.077 1.077 0 0 0 1.525 0l2.011-2.009a3.275 3.275 0 0 0-.077-4.7 3.356 3.356 0 0 0-4.611.141L14.22 11.16a1.086 1.086 0 0 0 .762 1.838ZM15.03 16.993a1.069 1.069 0 0 0-.763.314l-1.965 1.965a1.178 1.178 0 0 1-1.613.05 1.112 1.112 0 0 1 0-1.577l2.008-2.01c.983-1.031-.494-2.508-1.524-1.525l-2.016 2.01a3.243 3.243 0 0 0 2.282 5.555 3.41 3.41 0 0 0 2.409-.998l1.944-1.946a1.085 1.085 0 0 0-.763-1.838ZM18.649 18.13a.36.36 0 0 0-.509.508l1.357 1.356a.36.36 0 0 0 .508-.508L18.65 18.13ZM21.618 16.868l-2.171.127a.36.36 0 1 0 .021.719h.02l2.173-.127a.36.36 0 0 0-.043-.72ZM17.385 19.099a.352.352 0 0 0-.381.338l-.127 2.171a.36.36 0 0 0 .338.381h.021a.36.36 0 0 0 .36-.338l.127-2.174a.36.36 0 0 0-.338-.378ZM11.36 11.86a.357.357 0 0 0 .587-.117.36.36 0 0 0-.078-.391l-1.357-1.357a.36.36 0 1 0-.508.508l1.357 1.357ZM8.392 13.124l2.171-.127a.36.36 0 1 0-.04-.72l-2.174.128a.36.36 0 1 0 .022.72h.021ZM12.625 10.892h.021a.36.36 0 0 0 .36-.338l.127-2.172a.36.36 0 0 0-.338-.381.355.355 0 0 0-.381.338l-.127 2.174a.36.36 0 0 0 .338.379Z" />
    </g>
  </svg>
);

export default SvgComponent;
